import selectCurrentOrder from '%evp_ticket_frontend/js/redux/currentOrder/selectors/selectCurrentOrder';
import setWaitingHallUpdate from './setWaitingHallUpdate';
import { openSnackbar } from '%app/js/common/components/material/Snackbar';
import captureException from '%app/js/common/services/captureException';
import cartClient from '%evp_ticket_frontend/js/redux/currentCart/service/CartClient';
import selectDefaultPriceType from '%evp_ticket_frontend/js/redux/currentEvent/selectors/selectDefaultPriceType';
import buildResponseErrorNotification from '%paysera_seat_selection_integration/js/seatings/redux/service/buildResponseErrorNotification';
import { setCart } from '%evp_ticket_frontend/js/redux/currentCart';
import buildSeatingLabels from '%paysera_seat_selection_integration/js/seatings/redux/service/buildSeatingLabels/buildSeatingLabels';
import { seatingReserved } from '%paysera_seat_selection_integration/js/seatings/redux/components/orm/actions';
import { OBJECT_TYPE_GENERAL_ADMISSION } from '%paysera_seat_selection/js/seatSelection/config/constants';

function reserveSeating(seating, count, sectorId) {
    return async (dispatch, getState) => {
        try {
            if (!seating?.hash) {
                throw new TypeError('seating Hash not found.');
            }
            if (!seating?.ticketType?.hash) {
                throw new TypeError('seating.ticketType Hash not found.');
            }

            dispatch(setWaitingHallUpdate(true));
            const { token, user_id: userId } = selectCurrentOrder(getState());
            const priceType = selectDefaultPriceType(getState(), seating.ticketType.hash);
            const sectorIdParam = {};
            if (typeof sectorId === 'number') {
                sectorIdParam.sector_id = sectorId;
            }
            const reservation = {
                seating: {
                    hash: seating.hash,
                    type: seating.objectType,
                    labels: buildSeatingLabels(seating),
                },
                ticket_type: { hash: seating.ticketType.hash },
                price_type: { hash: priceType.hash },
                tickets_count: count,
                ...sectorIdParam,
            };

            const cart = await cartClient.reserve({ reservation, token });
            dispatch(seatingReserved({
                type: seating.objectType,
                hash: seating.hash,
                user: userId,
                seats_used: seating.objectType === OBJECT_TYPE_GENERAL_ADMISSION
                    ? seating.seatsUsed + count
                    : 1,
            }));
            dispatch(setCart(cart));
        } catch (error) {
            dispatch(openSnackbar(buildResponseErrorNotification(error)));
            captureException(error);
        } finally {
            dispatch(setWaitingHallUpdate(false));
        }
    };
}

export default reserveSeating;
